module.exports = __webpack_public_path__ + "static/media/boss-double-attack.3a8f7a36.png";